import { createStyles, makeStyles } from '@mui/styles';
import { Theme as DefaultTheme } from '@mui/material';
import { Color } from 'shared/utils/colors';
export const useStyles = makeStyles<DefaultTheme, { isMobile: boolean; glyphColor: Color }>(
  () =>
    createStyles({
      iconButton: {
        position: 'relative',
        left: '-8px',
        alignSelf: 'center',
        fontSize: '1rem',
        borderRadius: '4px',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: Color.border,
        '&:hover': {
          backgroundColor: Color.primaryOrangeHover,
        },
        '&.Mui-disabled': {
          borderColor: Color.border,
        },
      },
      // Page-level primary CTA. Matches the app-wide secondary "edit" buttons
      // (`secondaryActionButtonSx`): transparent fill, thin gray divider border,
      // brand-yellow tinted hover, so it no longer competes with the yellow menu
      // bar.
      button: {
        textTransform: 'none',
        color: Color.black,
        backgroundColor: 'transparent',
        borderRadius: '4px',
        borderStyle: 'solid',
        borderWidth: '1px !important',
        borderColor: Color.border,
        boxShadow: 'none',
        transition: 'background-color 0.15s ease-in-out',
        '&.MuiButton-root': {
          minWidth: '48px',
          fontSize: '1rem',
          padding: ({ isMobile }): string => (isMobile ? '6px 12px' : '6px 16px'),
        },
        '&:hover': {
          backgroundColor: Color.primaryOrangeHover,
          borderColor: Color.border,
          boxShadow: 'none',
        },
        // Transparent badge circle + dark glyph leaves a bold plus on the button
        // (black unless the caller passes `glyphColor`).
        '& .MuiButton-startIcon > div': {
          height: '26px',
          width: '26px',
          backgroundColor: 'transparent',
          color: ({ glyphColor }): Color => glyphColor,
          '& > .MuiSvgIcon-root': {
            width: '22px',
            height: '22px',
          },
        },
        '&.Mui-disabled': {
          color: Color.mutedBlack,
          backgroundColor: 'transparent',
          borderColor: Color.border,
          boxShadow: 'none',
        },
      },
    })
);
